import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'ACCOUNT_RESETTING_REQUEST_ERROR':
      return action.error;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'ACCOUNT_RESETTING_REQUEST_LOADING':
      return action.loading;

    default:
      return state;
  }
}

export function requested(state = null, action) {
  switch (action.type) {
    case 'ACCOUNT_RESETTING_REQUEST_SUCCESS':
      return action.requested;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, requested });
